import React from "react";
import Header from "./components/header/header";
import NavBar from "./components/navBar/navBar";
import Footer from "./components/footer/footer";
import AboutUs from "./components/aboutUs/aboutUs";
import PageTitle from "./components/pageTitle/pageTitle";

const InstituteCourseInfo = () => {
  return (
    <div>
      <Header />
      <NavBar />
      <PageTitle title={"Who we are"} breadcrumbSteps={["Home", "About Us"]} />
      <AboutUs />
      <Footer />
    </div>
  );
};

export default InstituteCourseInfo;
